<template>
  <div>
    <b-container fluid>
      <b-row>

        <!-- Listar categorias -->
        <b-col cols="12" lg="8">
          <h2>Categorias</h2>

          <b-link class="d-block mb-3 d-lg-none" href="#cadastrar-novo">Cadastrar nova categoria</b-link>

          <b-button variant="info" class="mb-3" @click="loadCategories">Recarregar categorias</b-button>

          <b-table
            :items="categories"
            :fields="tableFields"
            :busy="loading"
            striped
            hover
            responsive
            show-empty
            empty-text="Nenhuma categoria encontrada"
            class="my-4"
          >
            <template #cell(name)="data">
              {{ data.item.emoji ? data.item.emoji + ' ' + data.item.category : data.item.category }}
            </template>

            <template #cell(actions)="data">
              <b-button size="sm" variant="secondary" class="mr-1" @click="openEdit(data.item)">
                <icon scale="0.8" name="edit" class="mx-0"></icon>
              </b-button>
              <b-button size="sm" variant="danger" @click="confirmDelete(data.item)">
                <icon scale="0.8" name="trash" class="mx-0"></icon>
              </b-button>
            </template>
          </b-table>
        </b-col>

        <!-- Formulário -->
        <b-col cols="12" lg="4">
          <div id="cadastrar-novo" class="p-4" style="position: sticky; top: 0; background-color: #f8fbff;">
            <h2>{{ editingCategory ? 'Editar categoria' : 'Nova categoria' }}</h2>

            <b-alert :variant="feedback.type" dismissible :show="feedback.show" fade
              @dismissed="feedback.show = false">
              {{ feedback.data }}
            </b-alert>

            <b-form @submit.prevent="saveCategory">
              <b-form-group>
                <p class="mb-2 font-weight-bold">Emoji</p>
                <b-form-input
                  v-model="form.emoji"
                  maxlength="10"
                ></b-form-input>
                <small>Sugestão: copie um emoji em <a href="https://copychar.cc/emoji/" target="_blank">copychar.cc/emoji</a></small>
              </b-form-group>

              <b-form-group>
                <p class="mb-2 font-weight-bold">Nome da categoria</p>
                <b-form-input
                  v-model="form.category"
                  required
                ></b-form-input>
                <small>Exemplos: Bebidas, Comidas, etc.</small>
              </b-form-group>

              <b-button type="submit" variant="primary" :disabled="saving" class="mr-2">
                {{ editingCategory ? 'Salvar' : 'Cadastrar categoria' }}
              </b-button>
              <b-button v-if="editingCategory" variant="secondary" @click="resetForm">
                Cancelar edição
              </b-button>
            </b-form>
          </div>
        </b-col>

      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'OrganizerCategories',
  data() {
    return {
      organizer: null,
      categories: [],
      loading: false,
      saving: false,
      editingCategory: null,
      form: {
        emoji: '',
        category: ''
      },
      feedback: {
        show: false,
        type: '',
        data: ''
      },
      tableFields: [
        { key: 'name', label: 'Categoria' },
        { key: 'actions', label: 'Ações', class: ['text-nowrap'] }
      ]
    }
  },

  mounted() {
    this.organizer = this.$route.params.organizer
    this.loadCategories()
  },

  methods: {
    async loadCategories() {
      this.loading = true
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_URL_APP}/b/organizers/${this.organizer}/categories`
        )
        this.categories = response.body.categories || []
      } catch (e) {
        this.showFeedback('danger', 'Não foi possível carregar as categorias.')
      } finally {
        this.loading = false
      }
    },

    openEdit(category) {
      this.editingCategory = category
      this.form = { emoji: category.emoji, category: category.category }
      this.feedback.show = false
    },

    resetForm() {
      this.editingCategory = null
      this.form = { emoji: '', category: '' }
      this.feedback.show = false
    },

    async saveCategory() {
      if (!this.form.category || this.form.category.trim() === '') {
        this.showFeedback('danger', 'Nome é obrigatório.')
        return
      }

      this.saving = true
      this.feedback.show = false

      try {
        if (this.editingCategory) {
          await this.$http.put(
            `${process.env.VUE_APP_URL_APP}/b/organizers/${this.organizer}/categories/${this.editingCategory.id}`,
            { emoji: this.form.emoji, category: this.form.category }
          )
          this.showFeedback('success', 'Categoria atualizada.')
        } else {
          await this.$http.post(
            `${process.env.VUE_APP_URL_APP}/b/organizers/${this.organizer}/categories`,
            { emoji: this.form.emoji, category: this.form.category }
          )
          this.showFeedback('success', 'Categoria cadastrada.')
        }

        this.resetForm()
        await this.loadCategories()
      } catch (e) {
        const body = e.body || {}
        this.showFeedback('danger', body.message || 'Não foi possível salvar a categoria.')
      } finally {
        this.saving = false
      }
    },

    async confirmDelete(category) {
      const h = this.$createElement
      const action = await this.$bvModal.msgBoxConfirm(
        h('div', [
          'Excluir categoria:',
          h('div', { class: 'font-weight-bold mt-1 mb-1' }, `${category.emoji} ${category.category}`),
          'Os lotes associados perderão a categoria.'
        ]),
        {
          title: '⚠ Atenção',
          okVariant: 'danger',
          cancelVariant: 'secondary',
          okTitle: 'Excluir',
          cancelTitle: 'Cancelar',
          centered: true,
          hideHeaderClose: false
        }
      )

      if (action === false || !action) return

      try {
        await this.$http.delete(
          `${process.env.VUE_APP_URL_APP}/b/organizers/${this.organizer}/categories/${category.id}`
        )
        if (this.editingCategory && this.editingCategory.id === category.id) {
          this.resetForm()
        }
        await this.loadCategories()
      } catch (e) {
        const body = e.body || {}
        this.showFeedback('danger', body.message || 'Não foi possível excluir a categoria.')
      }
    },

    showFeedback(type, message) {
      this.feedback.type = type
      this.feedback.data = message
      this.feedback.show = true
    }
  }
}
</script>
